import {
  useDispatch,
  useSelector,
} from "@adsk/acc-issues-core/state/redux/hooks";
import { getDocumentsByUrn } from "@adsk/acc-issues-core/state/redux/ducks/documents";
import {
  DOCUMENT_SURFACE_TYPE,
  getSheetByUrn,
  SHEET_SURFACE_TYPE,
} from "@adsk/acc-issues-core/state/redux/ducks/sheets";
import { fetchActivityLogAction } from "@adsk/acc-issues-core/state/redux/ducks/issueActivityLog";
import {
  FeatureFlag,
  useFeatureFlag,
} from "@adsk/acc-issues-core/utils/featureFlags";
import { PaginatedResponse, ActivityBlock } from "@adsk/acc-issues-types";
import { useMemo } from "react";

export const useGetPlacementFileName = (placement: any): string => {
  const documentsByUrn = useSelector(getDocumentsByUrn);
  const findSheetByUrn = useSelector(getSheetByUrn);

  if (placement.surfaceType === DOCUMENT_SURFACE_TYPE) {
    const document = documentsByUrn[placement.urn];
    return document?.name;
  }
  if (placement.surfaceType === SHEET_SURFACE_TYPE) {
    const sheet = findSheetByUrn(placement.urn);
    return sheet?.fileName;
  }
  return "";
};

export const useFetchActivityLogAction = () => {
  const dispatch = useDispatch();
  const { value: shouldFetchIssueDeletedActivity } = useFeatureFlag(
    FeatureFlag.EnableDeletedIssuesSpace
  );

  const { value: shouldFetchIssueRestoredActivity } = useFeatureFlag(
    FeatureFlag.RestoreDeletedIssues
  );

  const { value: shouldShowSnapshotActivity } = useFeatureFlag(
    FeatureFlag.ShowSnapshotActivity
  );

  const { value: shouldShowAttachmentActivity } = useFeatureFlag(
    FeatureFlag.ShowAttachments
  );
  return useMemo(
    (): ((
        issueId: string,
        pagination?: { limit?: number; offset?: number }
      ) => Promise<PaginatedResponse<ActivityBlock> | null>) =>
      async (
        issueId: string,
        pagination: { limit?: number; offset?: number } = {}
      ): Promise<PaginatedResponse<ActivityBlock> | null> => {
        const customFilters = {
          placementActivities: true,
          deletedIssueActivity: shouldFetchIssueDeletedActivity,
          restoredIssueActivity: shouldFetchIssueRestoredActivity,
          snapshotIssueActivity: shouldShowSnapshotActivity,
          attachmentIssueActivity: shouldShowAttachmentActivity,
        };
        return await dispatch(
          fetchActivityLogAction(issueId, pagination, customFilters)
        );
      },
    [
      dispatch,
      shouldFetchIssueDeletedActivity,
      shouldFetchIssueRestoredActivity,
      shouldShowSnapshotActivity,
      shouldShowAttachmentActivity,
    ]
  );
};
